import { render, staticRenderFns } from "./IncidentTypePublish.vue?vue&type=template&id=e3d3d368"
import script from "./IncidentTypePublish.vue?vue&type=script&lang=js"
export * from "./IncidentTypePublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports